export default {
    // Navbar
    nav: {
      home: 'Startseite',
      about: 'Über mich',
      strategies: 'Strategien',
      performance: 'Performance',
      portfolioBuilder: 'Portfolio-Builder',
      insights: 'Analysen',
      reports: 'Wochenberichte',
      terminal: 'Quant Lab',
      contact: 'Kontakt',
      institutional: 'Institutionelle Investoren',
    },
    
    // Home Page
    home: {
      ticker: {
        subtitle: 'Quantitativer Handel · Systematische Strategien',
      },
      hero: {
        title: 'HMA Quant Strategies',
        description: 'Quantitativer Analyst entwickelt algorithmische Strategien mit annualisierten Renditen von über',
        cagr: '40% CAGR',
        and: 'und',
        sharpe: 'Sharpe > 1.5',
        additionalPrefix: 'Mit',
        drawdowns: 'Drawdowns',
        additionalMiddle: 'unter',
        drawdownValue: '15%',
        additionalAnd: 'und historischen Daten über',
        years: '20 Jahre',
        ctaPrimary: 'Strategien erkunden',
        ctaSecondary: 'Über mich',
      },
      featured: {
        label: 'Empfohlene Strategie',
        cta: 'ARES erkunden →',
      },
      tech: {
        label: 'Quantitative Infrastruktur',
        title: 'MATHEMATISCHE & ',
        titleAccent: 'COMPUTERTECHNISCHE WERKZEUGE',
        footer: 'Systematische Strategien validiert durch rigoroses Backtesting mit institutionellen Daten',
      },
      timeline: {
        label: 'Beruflicher Werdegang',
        title: 'KARRIERE-',
        titleAccent: 'MEILENSTEINE',
        milestones: [
          {
            title: 'Physik-Studium',
            description: 'Universitätsabschluss mit Spezialisierung auf theoretische Physik und angewandte Mathematik.',
          },
          {
            title: 'Master in Quantitativer Finanzwirtschaft',
            description: 'Spezialisierte Ausbildung in mathematischer Modellierung, quantitativer Analyse und Entwicklung algorithmischer Strategien.',
          },
          {
            title: 'Hedgefonds + Algorithmische Strategie',
            description: 'Einstieg bei spanischem Hedgefonds. Entwicklung und Implementierung einer dividendenbasierten algorithmischen Strategie.',
          },
          {
            title: 'IG Group (FTSE 100)',
            description: 'Eintritt bei IG Group Broker, FTSE 100-Komponente, Tätigkeit in quantitativer Entwicklung.',
          },
          {
            title: 'Strategien in Produktion',
            description: 'Mehrere algorithmische Strategien mit echtem Kapital in Produktion. Systematisches Trading-Portfolio operativ.',
          },
        ],
      },
      features: {
        title: 'Warum in quantitative Strategien investieren?',
        subtitle: 'Algorithmische Systeme basierend auf Daten, rigorosem Backtesting und institutionellem Risikomanagement',
        items: [
          {
            title: 'Momentum & Timing',
            description: '+40% CAGR bei Momentum- und Market-Timing-Strategien validiert über 15 Jahre historischer Daten'
          },
          {
            title: 'Bayesianische Modelle',
            description: 'Hidden Markov Models zur Marktregime-Erkennung und dynamischen Anpassung'
          },
          {
            title: 'Market Neutral',
            description: 'Long-Short-Strategien mit Beta/R²-Korrelationsanalyse zur Reduktion direktionaler Exposition'
          },
          {
            title: 'Automatisierte Systeme',
            description: 'Vollautomatisierbarer Intraday-Handel bei Prop-Firmen und institutionellen Brokern'
          },
          {
            title: 'Multi-Asset',
            description: 'US-Aktien, Indizes, Krypto, Volatilität (VIX) - echte Diversifikation'
          },
          {
            title: 'Institutioneller Track Record',
            description: 'Erfahrung im Management von Portfolios bis zu $200M bei Hedgefonds und FTSE 100-Brokern'
          }
        ]
      },
      cta: {
        title: 'Bereit anzufangen?',
        subtitle: 'Entdecken Sie meine Strategien auf Darwinex, eToro und Wikifolio, oder lesen Sie meine quantitativen Analysen auf Substack',
        ctaPrimary: 'Wo investieren',
        ctaSecondary: 'Kontakt'
      }
    },

    // About Me Page
    about: {
      title: 'Quantitativer Analyst',
      intro1: 'Quantitativer Analyst mit Hintergrund in',
      physics: 'Physik (BSc)',
      and: 'und',
      finance: 'quantitativer Finanzwirtschaft (MSc)',
      intro2: '. Derzeit tätig bei einem Londoner Broker (FTSE 100), Entwicklung statistischer Modelle und systematischer Handelsstrategien.',
      intro2b: 'Derzeit CFA (Chartered Financial Analyst) Kandidat — die renommierteste und weltweit anerkannte Zertifizierung in der Investmentbranche.',
      intro3: 'Mit vorheriger Erfahrung im Management von Portfolios bis zu',
      amount: '$200M bei einem spanischen Hedgefonds',
      intro4: ', sowie in Preisgestaltung und Risikomanagement von Energiederivaten bei einem Rohstofffonds, verbindet mathematische Strenge, Machine Learning und tiefes Marktverständnis, um robuste und reproduzierbare Algorithmen zu entwickeln.',
      trackRecordTitle: 'Erfolgsbilanz',
      trackRecordDescription: 'Entwicklung quantitativer Strategien, die konsistente risikobereinigte Renditen über alle Marktregime hinweg liefern. Unser Track Record spricht durch Zahlen: unabhängige Strategien entwickelt, um Drawdowns zu minimieren und gleichzeitig Alpha zu maximieren, jede durch Jahrzehnte historischer Daten stresstestiert und durch Live-Paper- und Real-Trading validiert. Einzeln zielt jede Strategie auf kontrolliertes Risiko innerhalb ihrer Anlageklasse ab. Kombiniert in einem diversifizierten Portfolio erreichen sie Sharpe Ratios über 1,5 und maximale Drawdowns unter -15%, mit nahezu null Korrelation zu traditionellen Benchmarks. Von momentumgetriebenen Aktienportfolios bis zu marktneutraler statistischer Arbitrage, von Volatilitätsabschöpfung bis zu quantitativem Makro, ob Sie ein Privatanleger sind, der systematisches Exposure sucht, oder eine Institution, die unkorrelierte Renditeströme anstrebt, wir entwickeln Strategien, die sich an Ihr Risikoprofil und Ihre Ziele anpassen.',
      trackRecordParagraph1: 'Entwicklung quantitativer Strategien, die konsistente risikobereinigte Renditen über Marktregime hinweg liefern. Berufserfahrung umfasst die Optimierung systematischer Strategien, Verbesserung risikobereinigter Renditen von 12% auf 23% annualisiert, und Beiträge zu Portfoliomanagement und Research mit verwalteten Vermögen über €200M.',
      trackRecordParagraph2: 'Entwicklung und Backtest von über 40 quantitativen Modellen über Aktien, Derivate und festverzinsliche Wertpapiere. Jede Strategie wurde über Jahrzehnte historischer Daten stresstestiert sowie durch Live-Paper-Trading und reale Marktbedingungen validiert.',
      trackRecordParagraph3: 'Einzeln zielt jede Strategie auf kontrolliertes Risiko innerhalb ihrer Anlageklasse ab. Kombiniert in einem diversifizierten Portfolio erreichen sie Sharpe Ratios über 1,5 und maximale Drawdowns unter -15%, mit nahezu null Korrelation zu traditionellen Benchmarks.',
      trackRecordDisclaimer: 'Performancezahlen basieren auf Backtesting und Live-Paper-Trading. Vergangene Ergebnisse garantieren keine zukünftigen Renditen. Alle Renditen sind hypothetisch, sofern nicht ausdrücklich als live angegeben.',
      trackRecordParagraph4: 'Von momentumgetriebenen Aktienportfolios bis zu marktneutraler statistischer Arbitrage, von Volatilitätsabschöpfung bis zu quantitativem Makro, ob Sie ein Privatanleger sind, der systematisches Exposure sucht, oder eine Institution, die unkorrelierte Renditeströme anstrebt, wir entwickeln Strategien, die sich an Ihr Risikoprofil und Ihre Ziele anpassen.',
      expertiseTitle: 'Fachkompetenz',
      expertise: [
        '+40% CAGR bei Momentum- und Timing-Strategien',
        'Bayesianische Modelle mit Hidden Markov Models zur Regimeerkennung',
        'Marktneutrale Strategien mit Beta/R²-Korrelationsanalyse',
        'Vollautomatisierbare Intraday-Systeme für Prop-Firmen',
        'Multi-Asset: US-Aktien, Indizes, Krypto, Volatilität (VIX)',
        'Institutioneller Track Record: Portfoliomanagement bis zu $200M',
      ],
      toolsTitle: 'Mathematische & Computertechnische Werkzeuge',
      toolsSubtitle: 'Technologien und Frameworks, die ich für quantitative Research und systematischen Handel verwende',
      clickToFlip: 'Klicken zum Umdrehen',
      clickToFlipBack: 'Klicken zum Zurückdrehen',
      clickForDetails: 'Klicken für Details →',
      clickToClose: 'Klicken zum Schließen ←',
      tools: {
        python: {
          name: 'Python',
          description: 'Hauptsprache für Backtesting, statistische Analyse und Strategieentwicklung'
        },
        numpy: {
          name: 'NumPy',
          description: 'Grundlegendes Paket für numerisches Rechnen und Array-Operationen'
        },
        pandas: {
          name: 'Pandas',
          description: 'Hochperformante Datenmanipulation und Analyse für Zeitreihen'
        },
        scikit: {
          name: 'Scikit-learn',
          description: 'Machine-Learning-Modelle für Mustererkennung und Vorhersageanalyse'
        },
        tensorflow: {
          name: 'TensorFlow',
          description: 'Deep-Learning-Framework für komplexe Marktverhaltenmodellierung'
        },
        pytorch: {
          name: 'PyTorch',
          description: 'Dynamische neuronale Netze für fortgeschrittene Deep-Learning-Forschung'
        },
        git: {
          name: 'Git',
          description: 'Versionskontrolle für Code-Management und kollaborative Entwicklung'
        },
        vscode: {
          name: 'VS Code',
          description: 'Professionelle IDE für effiziente Code-Entwicklung und Debugging'
        },
        jupyter: {
          name: 'Jupyter',
          description: 'Interaktive Notebooks für Research, Visualisierung und Strategie-Prototyping'
        },
        quantlib: {
          name: 'QuantLib',
          description: 'Quantitative Finanzbibliothek für Derivate-Pricing und Risikomanagement'
        },
        backtrader: {
          name: 'Backtrader',
          description: 'Python-Framework für Backtesting und Live-Trading von Strategien'
        },
        postgresql: {
          name: 'PostgreSQL',
          description: 'Robuste relationale Datenbank für strukturierte Finanzdatenspeicherung'
        },
        mongodb: {
          name: 'MongoDB',
          description: 'NoSQL-Datenbank für flexible unstrukturierte Marktdatenspeicherung'
        },
        docker: {
          name: 'Docker',
          description: 'Containerisierung für konsistente Bereitstellung über Umgebungen hinweg'
        },
        aws: {
          name: 'AWS',
          description: 'Cloud-Infrastruktur für skalierbares Computing und Datenverarbeitung'
        },
        mathematics: {
          name: 'Mathematik',
          description: 'Fortgeschrittene mathematische Konzepte der quantitativen Finanzwirtschaft'
        },
        statistics: {
          name: 'Statistik',
          description: 'Statistische Methoden für Hypothesentests und Inferenz'
        },
        linearalgebra: {
          name: 'Lineare Algebra',
          description: 'Matrixoperationen für Portfoliooptimierung und Faktormodelle'
        },
        timeseries: {
          name: 'Zeitreihen',
          description: 'Zeitdatenanalyse für Prognosen und Trenderkennung'
        },
        calculus: {
          name: 'Analysis',
          description: 'Ableitungen und Integrale für Optionspreisgestaltung und Optimierung'
        },
        probability: {
          name: 'Wahrscheinlichkeit',
          description: 'Probabilistische Modelle für Risikobewertung und Entscheidungsfindung'
        },
        optimization: {
          name: 'Optimierung',
          description: 'Mathematische Optimierung für Portfolioallokation und Strategieabstimmung'
        },
        bayesian: {
          name: 'Bayesianisch',
          description: 'Bayesianische Inferenz für Regimeerkennung und Parameterschätzung'
        },
        montecarlo: {
          name: 'Monte Carlo',
          description: 'Simulationsmethoden für Risikoanalyse und Szenariotests'
        }
      },
      ctaTitle: 'Bereit, anders zu investieren?',
      ctaSubtitle: 'Erkunden Sie meine quantitativen Strategien oder kontaktieren Sie mich.',
      ctaStrategies: 'Strategien ansehen',
      ctaContact: 'Kontakt',
      milestones: [
        {
          title: 'Physik-Studium',
          description: 'Universitätsabschluss mit Spezialisierung auf theoretische Physik und angewandte Mathematik.',
          shortDetail: 'Grundlagen in Analysis, linearer Algebra, Quantenmechanik, statistischer Mechanik, Elektromagnetismus, Relativitätstheorie und wissenschaftlicher Programmierung in Python/Fortran/C.'
        },
        {
          title: 'Master in Quantitativer Finanzwirtschaft',
          description: 'Spezialisierte Ausbildung in mathematischer Modellierung, quantitativer Analyse und Entwicklung algorithmischer Strategien.',
          shortDetail: 'Python-Programmierung, Ökonometrie, Derivate, Portfoliomanagement, Machine Learning, Deep Learning, NLP, Reinforcement Learning, AWS-Deployment und Quantencomputing.'
        },
        {
          title: 'Hedgefonds',
          description: 'Eintritt bei spanischem Hedgefonds mit Arbeit für erstklassige institutionelle Kunden.',
          shortDetail: 'Quantitativer Analyst mit Portfoliomanagement für Edmond de Rothschild, Millennium und US-Finanzfirmen. Datengesteuerte Studien, Prozessoptimierung und quantitative Research.'
        },
        {
          title: 'Energiehandel',
          description: 'Trading und Risikomanagement in globalen Energiemärkten für niederländisches Unternehmen.',
          shortDetail: 'Handelsmöglichkeiten in europäischen Energieverbindungen. Optimierungsprojekte für Repsol, Glencore, TMS. Reuters Eikon, ETRM-Entwicklung, CPLEX/Gurobi-Solver, Monte-Carlo-Pricing.'
        },
        {
          title: 'IG Group (FTSE 100)',
          description: 'Quantitativer Analyst bei FTSE 100-Broker, Entwicklung von ML-Modellen für Handelsoptimierung und Risikomanagement.',
          shortDetail: 'XGBoost/Random Forest-Modelle für Market-Maker-Risikomanagement. Statistische Research, PnL-Pipelines, GCP/BigQuery/Streamlit-Dashboards. Reporting für Teams in London und Melbourne.'
        },
        {
          title: 'Strategien in Produktion',
          description: 'Entwicklung und Betrieb proprietärer algorithmischer Strategien mit echtem Kapital über mehrere Anlageklassen.',
          shortDetail: 'Marktneutral, Momentum, Pair Trading, ML-basierter Handel, Forex, Krypto, Volatilitätsstrategien. Vollständige Pipeline von Hypothese bis Live-Execution. Siehe Strategies-Sektion für Details.'
        }
      ],
      eventsTitle: 'VERANSTALTUNGEN',
      eventsAttendTitle: 'VERANSTALTUNGEN, DIE ICH BESUCHE / EMPFEHLE',
      eventsOrganizeTitle: 'VERANSTALTUNGEN, DIE ICH ORGANISIERE / BEI DENEN ICH SPRECHE',
      eventAttending: 'TEILNEHMER',
      eventOrganizer: 'ORGANISATOR',
      eventQuantConference: 'Quant Finance Konferenz',
      eventQuantConferenceLocation: 'London, Juni 2026',
      eventQuantConferenceDesc: 'Führende Veranstaltung für quantitative Researcher und Praktiker. Fokus auf systematischem Handel und Risikomanagement.',
      eventQuantMeetup: 'Quant Finance Meetup',
      eventQuantMeetupLocation: 'Madrid, 2025',
      eventQuantMeetupDesc: 'Organisierte Community-Veranstaltung für quantitative Researcher und Praktiker. Fokus auf Austausch systematischer Handelsstrategien und Networking.',
      eventsComingSoon: 'Weitere Veranstaltungen demnächst...',
      podcastsTitle: 'PODCASTS · DEMNÄCHST',
      podcastsDescription: 'Eine Reihe von Gesprächen mit Praktikern, Researchern und Entwicklern im Bereich quantitative Finanzwirtschaft. Derzeit in Planung. Wenn Sie benachrichtigt werden möchten, wenn dies startet, abonnieren Sie über die Kontaktseite.',
      disclaimer: 'Die auf dieser Website bereitgestellten Informationen dienen nur zu Bildungs- und Informationszwecken. Sie stellen keine Finanz-, Anlage- oder Handelsberatung dar. Vergangene Performance garantiert keine zukünftigen Ergebnisse. Konsultieren Sie immer einen lizenzierten Finanzberater, bevor Sie Anlageentscheidungen treffen.',
    },

    // Strategies Page
    strategies: {
      title: 'Quantitative Strategien',
      subtitle: 'Algorithmische Systeme auf institutionellem Niveau mit rigorosem Backtesting',
      compareTitle: 'Performance-Vergleich',
      compareSubtitle: 'Vergleichen Sie Schlüsselmetriken aller Strategien',
      riskLevel: 'Risikolevel',
      moderate: 'Moderat',
      high: 'Hoch',
      veryHigh: 'Sehr hoch',
      viewStrategy: 'Strategie ansehen',
      equityCurve: 'EIGENKAPITALKURVE',
      drawdownAnalysis: 'DRAWDOWN-ANALYSE',
      maxDrawdownComparative: 'MAX DRAWDOWN VERGLEICH',
      comparativeMetrics: 'VERGLEICHSMETRIKEN',
      correlation: 'KORRELATION',
      correlationWithBenchmarks: 'KORRELATION MIT BENCHMARKS',
      downloadBrochure: '📄 Broschüre herunterladen',
      annualReturns: 'Jährliche Renditen',
      historicalDataDisclaimer: '* Historischer Datenzeitraum {start} - {end}. Vergangene Performance garantiert keine zukünftigen Renditen.',
      strategyNames: {
        tyr: 'TYR Strategie',
        ares: 'ARES Strategie',
        ascalafo: 'ASCÁLAFO Strategie',
        deimos: 'DEIMOS Strategie',
        fobos: 'FOBOS Strategie',
        bes: 'BES Strategie',
        janus: 'JANUS Strategie',
        hraesvelgr: 'HRÆSVELGR Strategie',
      },
      metrics: {
        cagr: 'CAGR',
        sharpe: 'Sharpe',
        maxDD: 'Max DD',
        volatility: 'Volatilität',
      },
      strategyDescriptions: {
        tyr: 'Dual-Momentum-Rotation',
        ares: 'Market Timing',
        ascalafo: 'Doppelschicht',
        deimos: 'Market Timing + Risiko',
        fobos: 'Doppelschicht + Risiko',
        bes: 'Trendfolge',
        janus: 'Sektorrotation',
        hraesvelgr: 'Aggressives All Weather',
      },
      strategyFullDescriptions: {
        tyr: 'TYR trägt den Namen des nordischen Gottes der Ordnung, Gerechtigkeit und des Schutzes, ein passendes Symbol für eine Strategie, die darauf ausgelegt ist, Märkte mit Disziplin und Widerstandsfähigkeit zu navigieren. TYR ist eine quantitative Dual-Momentum-Rotationsstrategie, inspiriert von den Prinzipien hinter Ray Dalios All Weather-Philosophie.',
        ares: 'ARES ist eine proprietäre quantitative Market-Timing-Strategie. Entwickelt und validiert über fast 20 Jahre historischer Daten (2006–2026), hat sie sich durch die stressigsten Episoden moderner Märkte als robust erwiesen: den Finanzcrash 2008, die Pandemie 2020, den aggressiven Zinserhöhungszyklus 2022 und die extreme Volatilität 2024–2025.',
        ascalafo: 'Proprietäre Doppelschicht-Market-Timing-Strategie auf dem US-Markt. Zwei unabhängige Signalsysteme, die sich für maximale Ein-/Ausstiegspräzision kombinieren. 100% systematisch, kontrollierte binäre Exposition.',
        deimos: 'DEIMOS ist eine proprietäre quantitative Market-Timing-Strategie mit höherem kontrollierten Risiko. Entwickelt und validiert über fast 20 Jahre historischer Daten (2006–2026), hat sie sich durch die stressigsten Episoden moderner Märkte als robust erwiesen. Mit einem aggressiveren Risikoprofil als ARES zielt sie darauf ab, Renditen in Bullenmärkten zu maximieren und gleichzeitig systematische Disziplin beizubehalten.',
        fobos: 'Proprietäre Doppelschicht-Market-Timing-Strategie auf dem US-Markt mit hohem Risiko-/Ertragsprofil. Zwei unabhängige Signalsysteme, die sich für maximale Ein-/Ausstiegspräzision kombinieren. 100% systematisch, kontrollierte binäre Exposition mit optimiertem Hebel für Investoren mit höherer Risikotoleranz.',
        bes: 'BES ist eine systematische Trendfolge-Strategie mit Fokus auf mittelfristiges Wachstum. Sie hält Titel, die den breiten Markt technisch übertreffen, und kombiniert Relative Stärke, Momentum und Trendstabilität, um Rauschen herauszufiltern.',
        janus: 'JANUS ist ein quantitatives Aktienauswahlsystem mit vollständigem wöchentlichem Rebalancing, das im Long-Short Market Neutral-Modus operiert. Sein Name evoziert den römischen Gott mit zwei Gesichtern — genau die Dualität, gleichzeitig Long- und Short-Positionen einzugehen.',
        hraesvelgr: 'HRÆSVELGR is TYR’s more aggressive twin in the All Weather family. Same regime discipline, more appetite for growth, and a faster shift to defence when momentum fades.',
      },
    },

    // Portfolio Builder Page
    portfolioBuilder: {
      title: 'Portfolio-Builder',
      subtitle: 'Erstellen Sie Ihr personalisiertes Portfolio durch Kombination mehrerer quantitativer Strategien',
      riskWarning: {
        title: '⚠ RISIKOWARNUNG',
        content: 'Quantitative Strategien beinhalten Kapitalverlustrisiko. Die gezeigte historische Performance basiert auf Backtesting und Simulation — sie garantiert keine zukünftigen Renditen. Dies ist ein Bildungswerkzeug, keine Anlageberatung, keine Empfehlung und keine Aufforderung zum Kauf oder Verkauf von Wertpapieren.',
      },
      hero: {
        heading1: 'ERSTELLEN SIE IHR',
        heading2: 'IDEALES PORTFOLIO',
        description: 'Erkunden Sie Portfoliokombinationen über unsere Strategien hinweg. Dieses Tool ermöglicht es Ihnen, Allokationen zu simulieren, historische Metriken zu analysieren und zu verstehen, wie unterschiedliche Strategiegewichtungen risikobereinigte Renditen beeinflussen. Dies ist ein Bildungswerkzeug — keine personalisierte Anlageberatung.',
        disclaimer: 'Nur Bildungswerkzeug. Simulierte Ergebnisse basierend auf historischen Daten. Keine Anlageberatung.',
      },
      tabs: {
        build: 'Portfolio erstellen',
        models: 'Modellportfolios',
        saved: 'Gespeicherte Portfolios',
      },
      buildSection: {
        selectTitle: 'Strategien auswählen',
        selectSubtitle: 'Wählen Sie mindestens 2 Strategien zum Kombinieren',
        weightsTitle: 'Gewichte zuweisen',
        weightsSubtitle: 'Gesamtsumme muss 100% ergeben',
        totalWeight: 'Gesamtgewicht',
        distributeEqually: 'Gleichmäßig verteilen',
        optimize: 'Auto-Optimierung (Sharpe)',
        generate: 'Portfolio generieren',
        validationError: 'Wählen Sie mindestens 2 Strategien und stellen Sie sicher, dass Gewichte 100% ergeben',
        optimizeSuccess: 'Portfolio optimiert mit erwarteter Sharpe:',
        optimizeError: 'Fehler bei Portfolio-Optimierung',
      },
      modelsSection: {
        title: 'Modellportfolios',
        subtitle: 'Vorkonfigurierte Portfolios für unterschiedliche Risikoprofile',
        usePortfolio: 'Dieses Portfolio verwenden',
        questionnaire: 'Fragebogen ausfüllen',
      },
      savedSection: {
        title: 'Gespeicherte Portfolios',
        subtitle: 'Greifen Sie auf Ihre zuvor gespeicherten Portfoliokonfigurationen zu',
        noSaved: 'Noch keine gespeicherten Portfolios',
        load: 'Laden',
        delete: 'Löschen',
      },
      results: {
        title: 'Portfolio-Ergebnisse',
        composition: 'Portfolio-Zusammensetzung',
        metrics: 'Schlüsselmetriken',
        performance: 'Historische Performance',
        returns: 'Monatliche Renditen',
        exportPDF: 'Portfolio-Bericht herunterladen',
        save: 'Portfolio speichern',
        saveSuccess: 'Portfolio erfolgreich gespeichert!',
        saveError: 'Fehler beim Speichern des Portfolios',
        period: 'Zeitraum',
        strategies: 'Strategien',
        tabs: {
          equity: 'Eigenkapitalkurve',
          drawdown: 'Drawdown',
          annual: 'Jährliche Renditen',
        },
        metricLabels: {
          cagr: 'CAGR',
          totalReturn: 'Gesamtrendite',
          sharpe: 'Sharpe',
          sortino: 'Sortino',
          maxDD: 'Max DD',
          calmar: 'Calmar',
          volatility: 'Volatilität',
          winRate: 'Gewinnquote',
          profitFactor: 'Gewinnfaktor',
          bestWeek: 'Beste Woche',
          worstWeek: 'Schlechteste Woche',
        },
        quickStart: {
          model: 'Modellportfolio',
          modelDesc: 'Beantworten Sie 5 Fragen und dieses Tool schlägt ein Modellportfolio basierend auf Ihrer Risikotoleranz vor',
          models: 'Modellportfolios',
          modelsDesc: 'Wählen Sie aus 6 von Experten entwickelten Portfolios: Konservativ, Moderat, Aggressiv und mehr',
          auto: 'Auto-Optimierung',
          autoDesc: 'Algorithmus findet optimale Gewichte zur automatischen Maximierung der Sharpe Ratio',
        },
        manual: {
          title: 'Manueller Builder',
          selectTitle: 'Strategien auswählen und Gewichte zuweisen',
        },
      },
    },

    // Insights Page
    insights: {
      title: 'Analysen',
      subtitle: 'Strategien, Analysen und Ressourcen für intelligentes Investieren',
      substackSection: {
        title: 'NEUESTE VON SUBSTACK',
        loading: 'Lade neueste Beiträge...',
        error: 'Fehler beim Laden der Artikel. Bitte versuchen Sie es später erneut.',
        errorWithLink: 'Neueste Artikel auf Substack:',
      },
      newsletterTitle: 'HMA Quant Newsletter',
      visitSubstack: 'Besuchen Sie meinen Substack',
      weeklyNewsletter: 'Wöchentlicher Newsletter',
      analysisAndNewsletter: 'Analyse & Newsletter',
      subscribe: 'Abonnieren',
      newsletterIntro: 'Ich teile quantitative Analysen, Investitionsthesen und tägliche Notizen zur S&P500-Optionskarte auf meinem Substack',
      newsletterDescription: 'Erhalten Sie tiefgreifende technische Analysen, quantitative Investitionsthesen und die tägliche S&P500-Optionskarte direkt in Ihre E-Mail. Exklusive Inhalte für Trader, die einen informativen Vorteil suchen.',
      newsletterBadge1: 'Quantitative Analyse',
      newsletterBadge2: 'Optionskarte',
      newsletterBadge3: 'Investitionsthesen',
      whereToInvestTitle: 'Wo investieren',
      whereToInvestSubtitle: 'Sie können meine quantitativen Strategien auf den folgenden regulierten Plattformen verfolgen. Jede Strategie hat ihr eigenes Risiko-Rendite-Profil und ist für Copy-Trading oder Direktinvestition verfügbar.',
      darwinex: {
        title: 'Darwinex',
        description: 'FCA-regulierte Plattform für Copy-Trading algorithmischer Strategien',
        strategies: 'Strategien',
      },
      etoro: {
        title: 'eToro',
        description: 'Social-Trading-Plattform mit Millionen Nutzern weltweit',
        profile: 'Mein Profil',
      },
      wikifolio: {
        title: 'Wikifolio',
        description: 'Europäische Plattform für investierbare Strategie-Zertifikate',
        profile: 'Mein Profil',
      },
      resourcesTitle: 'Bildungsressourcen',
      resourcesSubtitle: 'Artikel, Tools und Leitfäden zur Verbesserung Ihres quantitativen Investierens',
      comingSoon: 'Demnächst',
    },


    // Weekly Reports Page
    weeklyReports: {
      title: 'Wöchentliche Quantitative Berichte',
      subtitle: 'Abonnieren Sie detaillierte quantitative Research zu jeder Strategie. Jeder Bericht bietet eine tiefgreifende Analyse des mathematischen Frameworks, wöchentliche Modellentwicklungen, Portfoliobewegungen und die quantitative Begründung hinter der Evolution jeder Strategie.',
      subscriptionOptions: 'Abonnementoptionen',
      pricePerMonth: '€{price}/Monat',
      subscribe: 'Abonnieren',
      manage: 'Abonnement verwalten',
      alreadySubscribed: 'Bereits abonniert',
      signInToSubscribe: 'Anmelden zum Abonnieren',
      statusActive: 'Aktiv',
      statusCancelling: 'Endet am {date}',
      statusExpired: 'Abgelaufen',
      billingMonthly: 'Monatliche Abrechnung',
      cancelAnytime: 'Jederzeit kündbar',
      availableOnBrokers: 'Verfügbar bei allen großen Brokern',
      assetsLabel: 'Vermögenswerte:',
      whatYouGet: 'Was Sie erhalten:',
      subscribers: '{count} Abonnenten',
      loading: 'Laden...',
      errorLoading: 'Fehler beim Laden',
      subscribeTo: 'Abonnieren',
      subscribed: 'Abonniert',
      cancelsOn: 'Endet am',
      completeBundle: 'Komplettpaket',
      completeBundleDesc: 'Alle Strategien + Marktberichte + Quant Macro Insights',
      bestValue: 'BESTER WERT',
      perMonth: '/Monat',
      perYear: '/Jahr',
      planMonthly: 'Monatlich',
      planAnnual: 'Jährlich',
      twoMonthsFree: '2 Monate gratis',
      equivMonthly: 'entspr. €{price}/Monat',
      savingsText: '(€479,92 einzeln — sparen Sie €184,93 + Makro-Inhalte)',
      savingsTextAnnual: '(€4.799,92 einzeln — sparen Sie €1.849,93 + Makro-Inhalte)',
      getFullAccess: 'Vollzugriff erhalten',
      includes: 'Beinhaltet:',
      bundleIncludes: {
        strategies: 'Alle 22 Strategien (TYR, HRÆSVELGR, ARES, JANUS, BES, FOBOS, DEIMOS, ASCÁLAFO, EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER, HEIMDALL, METIS)',
        weeklyReports: 'Wöchentliche Berichte mit vollständiger Analyse',
        macroInsights: 'Quantitative makroökonomische Insights',
        historicalAccess: 'Vollständiger Zugriff auf historisches Archiv',
        transparentSignals: 'Signale mit transparenter Begründung',
      },
    },

    // Terminal Page
    terminal: {
      title: 'Terminal',
      watchlist_title: 'Watchlist',
      add_ticker_placeholder: 'Ticker eingeben + Enter',
      col_symbol: 'Symbol',
      col_price: 'Preis',
      col_change: 'Änd',
      col_change_pct: 'Änd %',
      col_volume: 'Volumen',
      col_day_range: 'Tagesspanne',
      footer_text: 'DATEN: YAHOO FINANCE · VERZÖGERT 15 MIN · NUR FÜR BILDUNGSZWECKE',
      // General
      quantLab: 'Quant Lab',
      marketData: 'Marktdaten',
      derivatives: 'Derivate',
      signals: 'Signale',
      research: 'Research',
      controls: 'Steuerung',
      statistics: 'Statistiken',
      numPaths: 'Anzahl Pfade',
      seed: 'Zufalls-Seed',
      showPaths: 'Pfade anzeigen',
      showMean: 'Mittelwert anzeigen',
      showDistribution: 'Verteilung anzeigen',
      showRegimes: 'Nach Regime einfärben',
      terminalMean: 'Terminaler Mittelwert',
      terminalStd: 'Terminale Std-Abw.',
      theoreticalMean: 'Theoretischer Mittelwert',
      theoreticalStd: 'Theoretische Std-Abw.',
      stationaryMean: 'Stationärer Mittelwert',
      stationaryStd: 'Stationäre Std-Abw.',
      pricePaths: 'Preispfade',
      meanReversion: 'Mean-Reversion-Prozess',
      terminalDistribution: 'Terminale Verteilung',
      priceWithRegimes: 'Preispfad mit Marktregimen',
      regimeStats: 'Regime-Statistiken',
      comingSoon: 'Demnächst',
      footer: 'Bildungswerkzeug für stochastische Prozess-Simulation',
      
      // Modules
      macroTerminal: 'Makro-Terminal',
      watchlist: 'Watchlist',
      charts: 'Charts',
      heatmap: 'Market Heatmap',
      optionsPricing: 'Options-Pricing',
      greeks: 'Greeks-Rechner',
      volatilitySurface: 'Volatilitätsoberfläche',
      liveSignals: 'Live-Signale',
      backtest: 'Backtest-Engine',
      economicCalendar: 'Wirtschaftskalender',
      newsAnalysis: 'Nachrichtenanalyse',

      // GBM
      gbm: {
        name: 'Geometrische Brownsche Bewegung',
        title: 'Geometrische Brownsche Bewegung',
        subtitle: 'Klassisches Modell für Aktienkursdynamik mit konstantem Drift und Volatilität',
      },

      // Ornstein-Uhlenbeck
      ou: {
        name: 'Ornstein-Uhlenbeck',
        title: 'Ornstein-Uhlenbeck-Prozess',
        subtitle: 'Mean-Reversion-Prozess für Zinssätze, Volatilität und Pairs-Trading',
      },

      // Regime Switching
      regime: {
        name: 'Regime-Wechsel',
        title: 'Regime-Wechsel-Modell',
        subtitle: 'Marktverhalten ändert sich über Bullen-, Neutral- und Bären-Regime',
      },
    },


    // Contact Page
    contact: {
      title: 'Kontakt aufnehmen',
      subtitle: 'Interessiert an quantitativen Strategien, Kooperationen oder Einstellungsmöglichkeiten? Kontaktieren Sie mich.',
      formTitle: 'Senden Sie mir eine Nachricht',
      formName: 'Name',
      formEmail: 'E-Mail',
      formMessage: 'Nachricht',
      formSubmit: 'Nachricht senden',
      infoTitle: 'Kontaktinformationen',
      emailLabel: 'E-Mail',
      emailLocked: 'Senden Sie Ihre E-Mail oben zum Freischalten',
      linkedinLabel: 'LinkedIn',
      substackLabel: 'Substack',
      fillAll: 'Bitte füllen Sie alle Felder aus',
      sent: 'Nachricht gesendet. Ich antworte bald.',
      sendError: 'Fehler beim Senden. Bitte erneut versuchen.',
      connectionError: 'Verbindungsfehler. Bitte später erneut versuchen.',
      sending: 'Senden…',
      methodLabel: 'Kontaktmethode',
      methodHint: 'Nutzen Sie das Formular. Ich antworte in der Regel innerhalb von 24–48 Stunden.',
    },

    // Returns Calculator Component
    calculator: {
      title: 'RENDITE-RECHNER',
      subtitle: 'Berechnen Sie, wie viel Sie verdient hätten, wenn Sie in',
      historicalData: 'mit echten historischen Daten investiert hätten',
      initialInvestment: 'Anfangsinvestition',
      monthlyContribution: 'Monatlicher Beitrag (Optional)',
      calculate: 'Renditen berechnen',
      results: {
        finalValue: 'ENDWERT',
        totalGain: 'GESAMTGEWINN',
        returnPercent: 'RENDITE %',
        summary: 'Zusammenfassung:',
        summaryText1: 'Mit einer Anfangsinvestition von',
        summaryText2: 'und monatlichen Beiträgen von',
        summaryText3: ', hätten Sie insgesamt investiert',
        summaryText4: 'über',
        summaryText5: ', und einen Endwert von',
        years: 'Jahre',
      },
    },

    // Footer
    footer: {
      rights: 'Alle Rechte vorbehalten',
      disclaimer: 'Vergangene Performance garantiert keine zukünftigen Ergebnisse. Trading beinhaltet Risiko.',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen',
      legal: 'Impressum',
    },

    // Common
    common: {
      present: 'Heute',
      loading: 'Laden...',
      error: 'Fehler',
      success: 'Erfolg',
      viewMore: 'Mehr ansehen',
      learnMore: 'Mehr erfahren',
      backToTop: 'Zurück nach oben',
      downloadBrochure: 'Broschüre herunterladen',
    },

    // Terminal Page
    terminal: {
      // Greeks Explorer
      greeksExplorer: {
        name: 'Greeks Explorer',
        title: 'GREEKS · OPTIONSSENSITIVITÄTEN',
        subtitle: 'Wie sich der Optionspreis bei Änderung der Inputs bewegt',
        introTitle: 'Einführung',
        introContent: 'Die Greeks sind partielle Ableitungen der Black-Scholes-Formel. Jede zeigt, wie der Optionspreis auf eine Änderung eines Inputs reagiert. Professionelle Trader schauen nicht auf Optionspreise — sie schauen auf Greeks. Ein Portfolio mit Delta = 0 ist "delta-neutral" — immun gegen kleine Bewegungen des Basiswerts. Ein Portfolio mit positivem Gamma ist "long convexity" — profitiert von jeder großen Bewegung nach oben oder unten. Greeks zu verstehen bedeutet zu verstehen, wie Optionen wirklich funktionieren.',
        controls: 'Steuerung',
        currentGreeks: 'Aktuelle Greeks',
        callOption: 'CALL-OPTION',
        putOption: 'PUT-OPTION',
        price: 'PREIS',
        labels: {
          spotPrice: 'S (Spot-Preis)',
          strike: 'K (Strike)',
          timeToExpiry: 'T (Zeit bis Verfallsdatum, Jahre)',
          riskFreeRate: 'r (Risikofreier Zinssatz)',
          volatility: 'σ (Volatilität)',
        },
        delta: {
          name: 'Δ (DELTA)',
          title: 'Δ (DELTA) · ∂V/∂S',
          description: 'Delta ist das Hedge-Verhältnis. Ein Call mit Delta 0,5 bedeutet, dass wir 0,5 Aktien leerverkaufen, um 1 Option abzusichern. Delta reicht von 0 bis 1 für Calls, -1 bis 0 für Puts.',
          formula: 'Formel',
          formulaNote: 'wobei Φ die kumulative Verteilungsfunktion der Standardnormalverteilung ist und d₁ = [ln(S/K) + (r + σ²/2)T] / (σ√T)',
        },
        gamma: {
          name: 'Γ (GAMMA)',
          title: 'Γ (GAMMA) · ∂²V/∂S² = ∂Δ/∂S',
          description: 'Gamma misst, wie schnell sich Delta ändert. Hohes Gamma = Delta schlägt bei kleinen Preisbewegungen heftig um. ATM-Optionen haben das höchste Gamma.',
          formula: 'Formel',
          formulaNote: 'wobei φ die Wahrscheinlichkeitsdichtefunktion der Standardnormalverteilung ist: φ(x) = (1/√(2π)) exp(-x²/2)',
        },
        vega: {
          name: 'V (VEGA)',
          title: 'V (VEGA) · ∂V/∂σ',
          description: 'Vega misst die Sensitivität gegenüber Volatilität. Long-Optionen = long Volatilität. Wenn σ um 1% steigt, steigt der Optionspreis um Vega.',
          formula: 'Formel',
          formulaNote: 'Vega ist für Calls und Puts gleich. Angezeigt für 1% Änderung der Volatilität.',
        },
        theta: {
          name: 'Θ (THETA)',
          title: 'Θ (THETA) · -∂V/∂t',
          description: 'Theta ist Zeitverfall. Long-Optionen verlieren mit der Zeit an Wert (negatives Theta). Short-Optionen profitieren (positives Theta) — der Grundpfeiler des Volatilitätsverkaufs.',
          formula: 'Formel',
          formulaNote: 'Angezeigt pro Tag. Theta ist typischerweise negativ für Long-Optionen (Zeitverfall).',
        },
        rho: {
          name: 'ρ (RHO)',
          title: 'ρ (RHO) · ∂V/∂r',
          description: 'Rho misst die Zinssensitivität. Für kurzlaufende Optionen ist Rho klein. Für LEAPS kann es viel ausmachen.',
          formula: 'Formel',
          formulaNote: 'Angezeigt für 1% Änderung des risikofreien Zinssatzes.',
        },
        inStrategies: 'Wie HMA dies nutzt',
        fobosStrategy: 'FOBOS handelt aktiv Volatilität über Optionen. Der Schlüssel-Greek für FOBOS ist Vega — wenn die implizite Volatilität relativ zur realisierten hoch ist, verkauft FOBOS Optionen, um Prämien zu ernten (negatives Vega). Wenn die implizite Vol unter die realisierte fällt, kauft FOBOS Konvexität über langes Gamma.',
        ascalafoStrategy: 'ASCÁLAFO führt systematische Optionsstrategien aus, bei denen Theta und Gamma dominieren. Theta ist der "Ertrag" aus dem Verkauf von Zeit, aber Gamma ist das Risiko — eine fette Bewegung löscht Wochen an Theta-Sammlung aus. Die Kunst besteht darin, Positionen so zu dimensionieren, dass das Theta/Gamma-Verhältnis das Risiko wert ist.',
      },

      // Black-Scholes Derivation
      bsDerivation: {
        name: 'Black-Scholes-Herleitung',
        title: 'BLACK-SCHOLES · AUS ERSTEN PRINZIPIEN',
        subtitle: 'Wie eine Gleichung, die einen Nobelpreis wert ist, tatsächlich aufgebaut wird',
        tabs: {
          tab1: '01 · DAS PROBLEM',
          tab2: '02 · BINOMIAL',
          tab3: '03 · REPLIKATION',
          tab4: '04 · KONTINUIERLICH',
          tab5: '05 · DIE PDE',
          tab6: '06 · FORMEL',
        },
        previous: 'ZURÜCK',
        next: 'WEITER',
        common: {
          stockPrice: 'Aktienkurs',
          strike: 'K',
          strikePrice: 'Strike-Preis',
          spotPrice: 'Spot-Preis',
          timeToExpiry: 'Zeit bis Verfall',
          riskFreeRate: 'Risikofreier Zinssatz',
          volatility: 'Volatilität',
          initialPrice: 'Anfangspreis',
          upFactor: 'Aufwärtsfaktor',
          downFactor: 'Abwärtsfaktor',
          timeStep: 'Zeitschritt',
          numberSteps: 'Anzahl Schritte',
          years: 'J',
        },
        tab1: {
          whatIsOption: 'Was ist eine Option?',
          whatIsOptionContent: 'Eine europäische Call-Option gibt Ihnen das Recht (nicht die Pflicht), einen Vermögenswert zu einem festen Preis K an einem festen Datum T zu KAUFEN. Wenn der Vermögenspreis S_T bei Verfall über K liegt, üben Sie aus und stecken S_T - K ein. Wenn darunter, gehen Sie mit null weg.',
          payoffFunction: 'Die Payoff-Funktion',
          payoffDesc: 'Bei Verfall ist die Option ihren intrinsischen Wert wert: die Differenz zwischen Spot und Strike oder null.',
          interactivePayoff: 'Interaktives Payoff-Diagramm',
          stockPriceAtExpiry: 'Aktienkurs bei Verfall',
          payoff: 'Payoff',
          callPayoff: 'Call Payoff',
          hockeyStick: 'Die Hockeyschläger-Form: null unter K, linear über K. Die gestrichelte Linie zeigt den Strike.',
          theQuestion: 'Die Frage, die Black-Scholes beantwortet',
          questionText: 'Wie viel sollten wir HEUTE für das Recht zahlen, MORGEN max(S_T - K, 0) zu erhalten?',
          questionExplanation: 'Der Payoff ist BEKANNT gegeben S_T. Das Problem ist, dass wir S_T nicht kennen. Black-Scholes zeigt uns, wie wir die Unsicherheit vollständig absichern können — unter idealisierten Annahmen — und so den fairen Preis der Option festlegen.',
          assumptions: 'Annahmen',
          assumptionsList: [
            'Die Aktie folgt einer geometrischen Brownschen Bewegung (siehe GBM-Modul)',
            'Konstante Volatilität σ',
            'Konstanter risikofreier Zinssatz r',
            'Keine Dividenden, keine Transaktionskosten, keine Steuern',
            'Kontinuierlicher Handel, perfekte Liquidität',
            'Europäische Ausübung (nur bei T, nicht vorher)',
          ],
        },
        tab2: {simplestUniverse: 'Einfachstes Universum', simplestUniverseContent: 'Ein Zeitschritt.', binomialTreeParams: 'Parameter', treeValues: 'Werte', up: 'HOCH', down: 'RUNTER', payoffUp: 'Payoff H', payoffDown: 'Payoff R', wrongApproach: 'FALSCH', wrongApproachText: 'Durchschnitt:', wrongApproachWarning: 'Falsch. Markt durch REPLIKATION.'},
        tab3: {centralIdea: 'Zentrale Idee', centralIdeaContent: 'Portfolio konstruieren.', replicationPortfolio: 'Replikation', replicationDesc: 'Portfolio = Δ + B', solvingSystem: 'Lösen', hedgeRatio: 'HEDGE', cash: 'BARGELD', optionPrice: 'PREIS', riskNeutralProb: 'Risikoneutral', riskNeutralText1: 'Nach Algebra:', riskNeutralText2: 'wobei:', profoundPoint: 'Punkt:', profoundText: 'p erscheint nie.', riskNeutralQ: 'q:', discountedPrice: 'Preis:'},
        tab4: {nStepIntro: 'N-Schritt', nStepContent: 'N Schritte.', crrParams: 'CRR', crrExplanation: 'GBM.', convergenceTitle: 'Konvergenz', convergenceChart: 'BS.', continuousLimit: 'Limit', continuousLimitContent: 'GBM.'},
        tab5: {derivationIntro: 'Stochastisch', derivationContent: 'GBM:', itosLemma: 'Itô', itosContent: 'Itô:', hedgePortfolio: 'Portfolio', hedgeContent: 'Π = V - Δ·S', noArbitrage: 'Kein Arbitrage', noArbitrageContent: 'Zinssatz:', noArbitrageExplanation: 'PDE:', bsPDE: 'PDE', boundaryConditions: 'Rand', boundaryContent: 'Call:', boundaryList: ['V(S,T)=max(S-K,0)', 'V(0,t)=0', 'V→S-K·e^(-r(T-t))'], keyInsight: 'Wichtig:', keyInsightContent: 'Parabolisch.'},
        tab6: {closedFormIntro: 'Formel', closedFormContent: 'Lösung:', bsFormulaCall: 'BS Call', bsFormulaWhere: 'wobei:', interactiveCalc: 'Rechner', callPrice: 'CALL', putPrice: 'PUT', priceVsSpot: 'Preis', bsPrice: 'BS', intrinsicValue: 'Intrinsisch', priceChartDesc: 'BS vs intrinsisch.', impact: 'Auswirkung', impactContent: '1973. Nobel.', greeksNext: 'Greeks: Ableitungen.'},
      },
    },
};
